export var STYLES = {
    error: 'color:red;font-weight:700',
    debug: 'font-weight:700',
    info: 'color:cyan;font-weight:700',
    trace: 'color:gray;font-weight:700',
    warn: 'color:orange;font-weight:700',
};
export var PRIORITY = {
    trace: 0,
    debug: 1,
    info: 2,
    warn: 3,
    error: 4,
};
